import { render } from "./harvesterhci.io.management.cluster.vue?vue&type=template&id=3407bc56"
import script from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__